import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createCustomExecutionEnvironment = async (object) => {
  try {
    return makeGraphQLRequest(
      graphqlOperation(mutations.createCustomExecutionEnvironment, {
        input: object,
      })
    );
  } catch (error) {
    console.error("Error creating CustomExecutionEnvironment:", error);
    throw error;
  }
};

const updateCustomExecutionEnvironment = async (id, args) => {
  try {
    // First, fetch the current version of the CustomExecutionEnvironment
    const getCustomExecutionEnvironmentResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getCustomExecutionEnvironment, { id })
    );
    const currentCustomExecutionEnvironment =
      getCustomExecutionEnvironmentResponse.data.getCustomExecutionEnvironment;

    // Prepare the update input
    const updateInput = { id, _version: currentCustomExecutionEnvironment._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    return makeGraphQLRequest(
      graphqlOperation(mutations.updateCustomExecutionEnvironment, {
        input: updateInput,
      })
    );
  } catch (error) {
    console.error("Error updating CustomExecutionEnvironment:", error);
    throw error;
  }
};

const deleteCustomExecutionEnvironment = async (id) => {
  try {
    // First, fetch the current version of the CustomExecutionEnvironment
    const getCustomExecutionEnvironmentResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getCustomExecutionEnvironment, { id })
    );
    const currentCustomExecutionEnvironment =
      getCustomExecutionEnvironmentResponse.data.getCustomExecutionEnvironment;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteCustomExecutionEnvironment, {
        input: { id, _version: currentCustomExecutionEnvironment._version },
      })
    );
    return response.data.deleteCustomExecutionEnvironment;
  } catch (error) {
    console.error("Error deleting CustomExecutionEnvironment:", error);
    throw error;
  }
};

const getCustomExecutionEnvironmentsByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.customExecutionEnvironmentByWorkspace, {
      workspaceID: workspaceID,
    })
  );

export default {
  createCustomExecutionEnvironment,
  updateCustomExecutionEnvironment,
  deleteCustomExecutionEnvironment,
  getCustomExecutionEnvironmentsByWorkspaceID,
};
